// extracted by mini-css-extract-plugin
module.exports = {"tag":"FilterHeaderTags__tag___1GZWc","title":"FilterHeaderTags__title___1DRWR"};